import React , {Component} from 'react';

class ProductAttr extends Component{
    state={
        active:'',
        elems:this.props.data
    }
    componentWillMount(){
        let {data}=this.props;
        this.setState({elems:data});
    }
    componentDidUpdate(prev){
        if(prev.data!==this.props.data){
            this.setState({elems:this.props.data});
        }
    }
    
    clickAttr=(active)=>{
        
        this.setState({active});
        this.props.clickAttr(active);
    }
    render(){
        let {elems , active}=this.state;
        let attributes=elems.map(elem=>{
            let classNames="btn btn-secondary btn-product-attr";
            if(active===elem)
                classNames+=" btn-active";

            return(
                <button
                onClick={()=>{this.clickAttr(elem)}}
                key={elem} type="button" className={classNames}>{elem}</button>
            );
        });
        return(
            <div className="btn-group btn-product-group" role="group" aria-label="Attributes">
                {attributes}
            </div>
        );
    }
}

export default ProductAttr;